export default {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  'SAAS-TRAINING': {
    TITLE: 'New SaaS users',
    KPI: {
      TOTAL: 'Total users',
      TOTAL_TOOLTIP: 'Total number of SaaS users matching the applied filters.',
      CONTACTED: 'Contacted',
      CONTACTED_TOOLTIP: 'Users who have already been contacted for SaaS training.',
      TRAINED: 'Trained',
      TRAINED_TOOLTIP: 'Users who have already completed SaaS training.',
      PENDING_TRAINING: 'Pending training',
      PENDING_TRAINING_TOOLTIP: 'Users who have not yet received SaaS training.',
    },
    FILTERS: {
      SEARCH: 'Search',
      SEARCH_PLACEHOLDER: 'Search by name, last name or email',
      ENTITY: 'Company',
      ENTITY_SEARCH: 'Search company...',
      ENTITY_SEARCH_HINT: 'Type 3 characters to search for the company',
      ENTITY_EMPTY: 'No companies available',
      ENTITY_EMPTY_FILTER: 'No companies found',
      CONTACTED: 'Contacted',
      TRAINED: 'Trained',
      CREATED_RANGE: 'Signup date',
      CONTACTED_RANGE: 'Contacted range',
      TRAINED_RANGE: 'Trained range',
      CLEAR: 'Clear filters',
      BUTTON: 'Filters',
      BUTTON_COUNT_SINGULAR: '1 filter',
      BUTTON_COUNT_PLURAL: '{{count}} filters',
      SIDEBAR_TITLE: 'Filters',
      APPLY: 'Apply filters',
      RESET_TOOLTIP: 'Clear filters',
    },
    TABLE: {
      TITLE: 'SaaS users',
      HEADER: {
        ID: 'Id',
        FIRSTNAME: 'First name',
        LASTNAME: 'Last name',
        EMAIL: 'Email',
        COMPANY: 'Company',
        ROLE: 'Role',
        CREATED_AT: 'Signup date',
        CONTACTED_AT: 'Contacted',
        TRAINED_AT: 'Trained',
      },
      BODY: { NO: 'No' },
      NO_DATA: 'No users match the selected filters',
    },
    BULK: {
      SELECTED: '{{count}} selected',
      MARK_CONTACTED: 'Mark contacted',
      MARK_TRAINED: 'Mark trained',
      CLEAR_CONTACTED: 'Clear contacted',
      CLEAR_TRAINED: 'Clear trained',
      MARK_TITLE: 'Set date',
      CLEAR_TITLE: 'Clear date',
      MARK_MESSAGE: 'You are about to mark {{count}} users as {{action}}. Choose the date to apply.',
      CLEAR_MESSAGE: 'You are about to clear {{action}} for {{count}} users.',
      ACTION_CONTACT: 'contacted',
      ACTION_TRAINING: 'trained',
      DATE: 'Date',
      DATE_REQUIRED: 'You must select a date',
    },
    SUCCESS: {
      HEADER: 'Success',
      BULK_UPDATED: '{{updated}} updated, {{skipped}} skipped',
    },
    ERRORS: {
      GENERIC_ERROR: 'An error occurred',
      USER_IDS_NOT_BLANK: 'You must select at least one user',
      DATE_RANGE_INVALID: 'The date range is invalid',
      ENTITY_ID_WRONG: 'The selected company is invalid',
      START_DATE_WRONG: 'The start date is invalid',
      END_DATE_WRONG: 'The end date is invalid',
      CONTACTED_FROM_WRONG: 'The contacted-from date is invalid',
      CONTACTED_TO_WRONG: 'The contacted-to date is invalid',
      TRAINED_FROM_WRONG: 'The trained-from date is invalid',
      TRAINED_TO_WRONG: 'The trained-to date is invalid',
    },
  },
};
